module.exports = __webpack_public_path__ + "img/Brian.65863947.jpg";